module.exports = __webpack_public_path__ + "static/media/record.924ecb38.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/schedule/record.png
// module id = 2115
// module chunks = 6